const doctors = [
    {
        name: "Kalpana Jha",
        email: "lakshitjainprof@gmail.com",
        role: "Psychologist",
        github: "https://github.com/LakshitJain25",
        linkedin: "https://www.linkedin.com/in/lakshit-jain-2bb2a4220/"
    },
    {
        name: "Shreya Khurana",
        email: "anmol.wri@gmail.com",
        role: "Psychiatrist",
        github: "https://github.com/anmolwadhwaxx",
        linkedin: "https://www.linkedin.com/in/anmol-wadhwa/"
    },
    {
        name: "Muskan Mishra",
        email: "khubchandanividhi613@gmail.com",
        role: "Psychologist",
        github: "https://www.linkedin.com/in/vidhi-khubchandani-133646202/",
        linkedin: "https://www.linkedin.com/in/vidhi-khubchandani-133646202/"
    },
    {
        name: "Chahat Bansal",
        email: "vaibhavikamble2915@gmail.com",
        role: "Psychologist",
        github: "https://www.linkedin.com/in/vaibhavi-kamble-b33364204/",
        linkedin: "https://www.linkedin.com/in/vaibhavi-kamble-b33364204/"
    },
    {
        name: "Anubhuti Jain",
        email: "lakshitjainprof@gmail.com",
        role: "Counsellor",
        github: "https://github.com/LakshitJain25",
        linkedin: "https://www.linkedin.com/in/lakshit-jain-2bb2a4220/"
    },
    {
        name: "Shoham Jha",
        email: "anmol.wri@gmail.com",
        role: "counsellor",
        github: "https://github.com/anmolwadhwaxx",
        linkedin: "https://www.linkedin.com/in/anmol-wadhwa/"
    },
    {
        name: "Kriti Arora",
        email: "khubchandanividhi613@gmail.com",
        role: "Psychologist",
        github: "https://www.linkedin.com/in/vidhi-khubchandani-133646202/",
        linkedin: "https://www.linkedin.com/in/vidhi-khubchandani-133646202/"
    },
    {
        name: "Bhumika Agarwal",
        email: "vaibhavikamble2915@gmail.com",
        role: "Psychologist",
        github: "https://www.linkedin.com/in/vaibhavi-kamble-b33364204/",
        linkedin: "https://www.linkedin.com/in/vaibhavi-kamble-b33364204/"
    },
    {
        name: "Riya Gupta",
        email: "lakshitjainprof@gmail.com",
        role: "counsellor",
        github: "https://github.com/LakshitJain25",
        linkedin: "https://www.linkedin.com/in/lakshit-jain-2bb2a4220/"
    },
    {
        name: "Ridima Sharma",
        email: "anmol.wri@gmail.com",
        role: "Psychologist",
        github: "https://github.com/anmolwadhwaxx",
        linkedin: "https://www.linkedin.com/in/anmol-wadhwa/"
    },
    {
        name: "Misha Bansal",
        email: "khubchandanividhi613@gmail.com",
        role: "Counsellor",
        github: "https://www.linkedin.com/in/vidhi-khubchandani-133646202/",
        linkedin: "https://www.linkedin.com/in/vidhi-khubchandani-133646202/"
    },
    {
        name: "Tanvi Shah",
        email: "vaibhavikamble2915@gmail.com",
        role: "Psychologist",
        github: "https://www.linkedin.com/in/vaibhavi-kamble-b33364204/",
        linkedin: "https://www.linkedin.com/in/vaibhavi-kamble-b33364204/"
    },

]
export default doctors
